@if (shouldDisplayNavbar()) {
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
      <a class="navbar-brand" href="#">
        <img src="assets/images/cc_reverse@2x.png" alt="Walrus Logo" height="32">
      </a>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
        aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ms-auto">
          <li class="nav-item">
            <a class="nav-link" routerLink="/dashboard" routerLinkActive="active">DASHBOARD</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/logs" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: false }">LOGS</a>
          </li>
          <!-- <li class="nav-item">
          <a class="nav-link" routerLink="/menu3" routerLinkActive="active">Menu 3</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/menu4" routerLinkActive="active">Menu 4</a>
        </li> -->
        <!-- <li class="nav-item d-flex align-items-center me-2">
        <div ngbDropdown class="d-inline-block">
          <button class="nav-link dropdown-toggle d-flex align-items-center" id="profileDropdown" ngbDropdownToggle
            type="button">
            <span class="me-2">{{ authService.getItem('username') || 'Classcover' }}</span>
            <img src="assets/images/profile.png" alt="Profile" class="rounded-circle" height="30" width="30">
          </button>
          <div ngbDropdownMenu aria-labelledby="profileDropdown" class="dropdown-menu dropdown-menu-end">
            <button ngbDropdownItem class="dropdown-item" type="button" (click)="onLogout($event)">Logout</button>
          </div>
        </div>
      </li> -->
      <li class="nav-item d-flex align-items-center">
        <div ngbDropdown class="d-inline-block">
          <!-- Dropdown toggle (shows current selection) -->
          <button class="btn nav-link dropdown-toggle d-flex align-items-center" id="timezoneDropdown"
            ngbDropdownToggle type="button">
            <img [src]="getFlag(currentZone)" alt="Flag" height="20" class="me-2">
            <!-- <span>{{ getZoneName(currentZone) }}</span> -->
          </button>
          <!-- Dropdown menu (list of options) -->
          <div ngbDropdownMenu aria-labelledby="timezoneDropdown" class="dropdown-menu dropdown-menu-end">
            @for (zone of zones; track zone) {
              <button ngbDropdownItem class="dropdown-item d-flex align-items-center"
                (click)="onSelectZone(zone.value)">
                <img [src]="zone.flag" alt="Flag" height="20" class="me-2">
                <span>{{ zone.label }}</span>
              </button>
            }
          </div>
        </div>
      </li>
      <li class="nav-item d-flex align-items-center">
        <button class="dropdown-item" type="button" (click)="onLogout($event)"><i class="fa fa-sign-out text-white" ngbTooltip="Logout"
        aria-hidden="true"></i>
      </button>
    </li>
  </ul>
</div>
</div>
</nav>
}